<template>
  <CSidebar
    fixed
    breakpoint="lg"
    class="role-theme-sidebar"
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CRenderFunction flat :contentToRender="navs"/>
  </CSidebar>
</template>

<script>
import { bindSidebarTooltips, refreshSidebarTooltips, unbindSidebarTooltips } from '@/components/common/sidebarTooltip'

export default {
  name: 'TheSidebar',
  computed: {
    show() {
      return this.$store.state.sidebarShow
    },
    minimize() {
      return this.$store.state.sidebarMinimize
    },
    navs() {
      void this.$store.state.locale.lang
      return [{
        _name: 'CSidebarNav',
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.dashboard'),
            to: '/supervisor/dashboard',
            icon: 'cil-speedometer'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.main'),
            to: '/supervisor/mainsupervisor',
            icon: 'cil-home'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.evaluation'),
            to: '/supervisor/evaluation',
            icon: 'cil-star'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.history'),
            to: '/supervisor/history',
            icon: 'cil-history'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.staff'),
            to: '/supervisor/UsersList',
            icon: 'cil-people'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.userManual'),
            to: '/supervisor/manual',
            icon: 'cil-book'
          }
        ]
      }]
    },
  },
  mounted() { bindSidebarTooltips(this); this.syncSidebarTooltips() },
  updated() { this.syncSidebarTooltips() },
  beforeDestroy() { unbindSidebarTooltips(this) },
  methods: {
    syncSidebarTooltips() {
      refreshSidebarTooltips(this, this.navs[0]._children.map(item => item.name))
    },
  },
}
</script>
